import { SearchSortFilter } from '../shared/searchSortFilter';

export class FormTemplatesFilter extends SearchSortFilter {
  constructor() {
    super();
  }
}
